<template functional>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
  >
    <g transform="translate(2.6 1.2)">
      <path d="M8.063,4.3l2.8-2.8,2.8,2.8" transform="translate(-5.529 -1.5)" fill="none" stroke="#d6001b" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" :style="{ fill: 'none !important' }" />
      <path d="M12,8.967V1.5" transform="translate(-6.667 -1.5)" fill="none" stroke="#d6001b" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" :style="{ fill: 'none !important' }" />
      <path d="M13.033,9.375h1.6a.533.533,0,0,1,.533.533v6.667a.533.533,0,0,1-.533.533h-9.6a.533.533,0,0,1-.533-.533V9.908a.533.533,0,0,1,.533-.533h1.6" transform="translate(-4.5 -3.775)" fill="none" stroke="#d6001b" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" :style="{ fill: 'none !important' }" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconImport',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>